
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import Tippy from '../../../node_modules/@tippyjs/react/headless/dist/tippy-react-headless.esm.js';
import { tooltipContainer } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["parentProps", "children", "content", "as", "placement", "maxWidth", "interactive"];
var Tooltip = function Tooltip(_ref) {
  var parentProps = _ref.parentProps,
    children = _ref.children,
    content = _ref.content,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? "div" : _ref$as,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top" : _ref$placement,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 350 : _ref$maxWidth,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Tag = as;
  var tagProps = _objectSpread2({
    role: "tooltip"
  }, parentProps);
  return jsx(Tippy, _extends({
    placement: placement,
    interactive: interactive,
    appendTo: document.body,
    render: function render(attrs) {
      return jsx("div", _extends({
        className: "tooltip",
        role: "alert",
        css: function css(theme) {
          return tooltipContainer(maxWidth, theme);
        }
      }, attrs), content, jsx("div", {
        id: "arrow",
        "data-testid": "tooltip-arrow",
        "data-popper-arrow": true
      }));
    }
  }, rest), jsx(Tag, tagProps, children));
};

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
